export const blockchainsConnectionInfo = {
    1: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=1',
        scan: 'https://etherscan.io/',
        rpc: [
            'https://eth-mainnet.alchemyapi.io/v2/V5qpPCasKHZ1MnYZLRz0gInhVXeaRh0V',
            'https://eth-mainnet.alchemyapi.io/v2/7NdSx33E9yNicR0xIFi85jU8G7pEfLY1',
        ],
        coinsId: 'ethereum',
        tokensId: 'ethereum',
        ExplorerApi: 'WIDK2MPTVHH1TMVYJICS5JDZVMKUC3ZIJF',
        gsn: {
            rpc: [
                'https://rpc.ankr.com/eth',
                'https://eth-rpc.gateway.pokt.network',
                'https://eth-mainnet.public.blastapi.io',
                'https://ethereum.publicnode.com',
                'https://eth.public-rpc.com',
            ],
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 2e5,
                relayRegistrationLookupBlocks: 2e5,
                pastEventsQueryMaxPageSize: Number.MAX_SAFE_INTEGER,
            },
        },
    },
    //|Görli
    5: {
        explorer: 'https://api-goerli.etherscan.io/api',
        scan: 'https://goerli.etherscan.io/',
        rpc: [
            'https://eth-goerli.g.alchemy.com/v2/mYiO4yTkY6GqVl96FkM5uJnnEb68NhCz',
            'https://eth-goerli.g.alchemy.com/v2/45B406IBlDc3EIK0-pJZuD3bB3nIZFwK',
        ],
        coinsId: 'ethereum',
        tokensId: 'ethereum',
        ExplorerApi: 'WIDK2MPTVHH1TMVYJICS5JDZVMKUC3ZIJF',
    },
    //sepolia
    11155111: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=11155111',
        scan: 'https://sepolia.etherscan.io/',
        rpc: [
            'https://rpc.sepolia.ethpandaops.io',
            'https://eth-sepolia.public.blastapi.io',
            'https://ethereum-sepolia-rpc.publicnode.com',
            'https://sepolia.drpc.org'
        ],
        coinsId: 'ethereum',
        tokensId: 'ethereum',
        ExplorerApi: '4FX9STMJQ4HPRWH3Z3SIXZV9X13NK9TYAP',
    },
    //Avalanche
    43114: {
        explorer: 'https://api.snowtrace.io/api',
        scan: 'https://snowtrace.io/',
        rpc: [
            'https://rpc.ankr.com/avalanche',
            'https://api.avax.network/ext/bc/C/rpc',
            'https://ava-mainnet.public.blastapi.io/ext/bc/C/rpc',
            'https://avalanche-evm.publicnode.com',
        ],
        coinsId: 'avalanche-2',
        tokensId: 'avalanche',
        ExplorerApi: 'YRIZ86JXZJTA5GRZ3EMGWDH72R8T4MX2IJ',
        gsn: {
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 4000,
                relayRegistrationLookupBlocks: 4000,
                pastEventsQueryMaxPageSize: 2000,
            },
        },
    },
    43113: {
        explorer: 'https://api-testnet.snowtrace.io/api',
        scan: 'https://testnet.snowtrace.io/',
        rpc: [
            'https://ava-testnet.public.blastapi.io/ext/bc/C/rpc',
            'https://api.avax-test.network/ext/bc/C/rpc',
        ],
        coinsId: '',
        tokensId: '',
        ExplorerApi: 'YRIZ86JXZJTA5GRZ3EMGWDH72R8T4MX2IJ',
        gsn: {
            rpc: [ 'https://api.avax-test.network/ext/bc/C/rpc' ],
            config: {
                paymasterAddress: '0x0c55A115767f8d37A522De9Df8BD6855381Aaa6e',
                relayLookupWindowBlocks: 4000,
                relayRegistrationLookupBlocks: 4000,
                pastEventsQueryMaxPageSize: 2000,
            },
        },
    },
    //Optimism
    10: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=10',
        scan: 'https://optimistic.etherscan.io/',
        rpc: [
            // "https://mainnet.optimism.io",
            'https://opt-mainnet.g.alchemy.com/v2/demo',
            'https://optimism-mainnet.public.blastapi.io',
            'https://rpc.ankr.com/optimism',
        ],
        coinsId: 'ethereum',
        tokensId: 'optimism',
        ExplorerApi: 'DJG3G4SUC2S77XXSB5KGUZV1TN6HREAMR3',
        gsn: {
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 250000,
                relayRegistrationLookupBlocks: 250000,
                pastEventsQueryMaxPageSize: 9900,
            },
        },
    },
    //Arbitrum One
    42161: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=42161',
        scan: 'https://arbiscan.io/',
        rpc: [
            'https://arb1.arbitrum.io/rpc',
            'https://endpoints.omniatech.io/v1/arbitrum/one/public',
            'https://rpc.ankr.com/arbitrum',
        ],
        coinsId: 'ethereum',
        tokensId: 'arbitrum-one',
        ExplorerApi: 'EQD75SYP5QAZBQ3VATJRIG9G2683KNS6TY',
    },
    //Fantom Opera
    250: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=250',
        scan: 'https://ftmscan.com/',
        rpc: [
            'https://rpc.ftm.tools/',
            'https://rpc.fantom.network',
            'https://rpc.ankr.com/fantom',
            'https://rpcapi.fantom.network',
        ],
        coinsId: 'fantom',
        tokensId: 'fantom',
        ExplorerApi: 'N4978V4B24V9ZVDC4Y583YSAFZDJTXIEUN',
    },
    //BSC
    56: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=56',
        scan: 'https://bscscan.com/',
        rpc: [
            'https://bsc-dataseed.binance.org/',
            'https://bsc-dataseed1.defibit.io/',
            'https://bsc-dataseed1.ninicoin.io/',
        ],
        coinsId: 'binancecoin',
        tokensId: 'binance-smart-chain',
        ExplorerApi: '85UGHD22WX3FE7P1XRINNS9TSI3WQDT7HT',
        gsn: {
            rpc: [
                'https://bscrpc.com',
                'https://rpc.ankr.com/bsc',
                'https://binance.ankr.com',
            ],
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 4990,
                relayRegistrationLookupBlocks: 4990,
                pastEventsQueryMaxPageSize: 999,
            },
        },
    },
    97: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=97',
        scan: 'https://testnet.bscscan.com/',
        rpc: [
            'https://bsc-testnet.public.blastapi.io',
            'https://bsc-testnet.public.blastapi.io',
            'https://data-seed-prebsc-1-s1.binance.org:8545',
            'https://data-seed-prebsc-1-s1.binance.org:8545',
        ],
        coinsId: 'binancecoin',
        tokensId: 'binance-smart-chain',
        ExplorerApi: '85UGHD22WX3FE7P1XRINNS9TSI3WQDT7HT',
        gsn: {
            rpc: [ 'https://bsc-testnet.publicnode.com' ],
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 4990,
                relayRegistrationLookupBlocks: 4990,
                pastEventsQueryMaxPageSize: 999,
                preferredRelays: [ 'https://gr.uprotel.com/gsn1' ],
            },
        },
    },
    //polygon
    137: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=137',
        scan: 'https://polygonscan.com/',
        rpc: [
            'https://rpc.ankr.com/polygon',
            'https://polygon-rpc.com',
            // 'https://polygon-mainnet.public.blastapi.io',

            'https://polygon-mainnet.g.alchemy.com/v2/cg1QXJzSBIJUIU7TUYXEDJzRKGR-1Icz/',
            'https://polygon-mainnet.g.alchemy.com/v2/hnyR1sr_yWa3gzSJ0-WF-66N429dVkrf',
            'https://polygon-mainnet.g.alchemy.com/v2/3rWlEdzx1pIZ1RNMRMWX3GHnUVQZT4JB',
        ],
        coinsId: 'matic-network',
        tokensId: 'polygon-pos',
        ExplorerApi: 'IY3Z1D4V7XBG8PJBAETCP5D25XAJI35HXE',
        gsn: {
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 990,
                relayRegistrationLookupBlocks: 990,
                pastEventsQueryMaxPageSize: 990,
            },
        },
    },
    80002: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=80002',
        scan: 'https://amoy.polygonscan.com',
        rpc: [
            // 'https://rpc-amoy.polygon.technology',
            'https://polygon-amoy.drpc.org',
            'https://polygon-amoy-bor-rpc.publicnode.com',
            'https://polygon-amoy.blockpi.network/v1/rpc/public',
            'https://polygon-amoy.g.alchemy.com/v2/uhdNWjVnw-5ClHctRr2SQJQNjLpLhj5x',
        ],
        coinsId: 'matic-network',
        tokensId: 'polygon-pos',
        ExplorerApi: 'IY3Z1D4V7XBG8PJBAETCP5D25XAJI35HXE',
        gsn: {
            rpc: [
                'https://rpc-amoy.polygon.technology',
                'https://polygon-amoy-bor-rpc.publicnode.com',
                'https://polygon-amoy.g.alchemy.com/v2/uhdNWjVnw-5ClHctRr2SQJQNjLpLhj5x',
            ],
            config: {
                paymasterAddress: null,
                relayLookupWindowBlocks: 990,
                relayRegistrationLookupBlocks: 990,
                pastEventsQueryMaxPageSize: 990,
            },
        },
    },
    8453: {
        explorer: 'https://api.etherscan.io/v2/api?chainid=8453',
        scan: 'https://basescan.org/',
        rpc: [
            // 'https://base-pokt.nodies.app',
            // 'https://base.meowrpc.com',
            // 'https://base.gateway.tenderly.co',
            'https://1rpc.io/base',
            'https://base-mainnet.public.blastapi.io',
            'https://base-rpc.publicnode.com',
            'https://mainnet.base.org'
        ],
        coinsId: 'base-network',
        tokensId: 'base',
        ExplorerApi: 'G3CQ678G9WPDBC3BDNDMTWIETXVKEUQTTT',
    },
    //pulseChain
    943: {
        explorer: 'https://api.scan.v4.testnet.pulsechain.com/api/v2',
        scan: 'https://scan.v4.testnet.pulsechain.com/#/',
        rpc: [ 'https://rpc.v4.testnet.pulsechain.com' ],
        coinsId: '',
        tokensId: '',
        ExplorerApi: '',
    },
    369: {
        explorer: 'https://api.scan.pulsechain.com/api/v2',
        scan: 'https://scan.pulsechain.com/',
        rpc: [ 'https://rpc.pulsechain.com' ],
        coinsId: '',
        tokensId: '',
        ExplorerApi: '',
    },
};
